import { mapActions, mapState } from 'vuex';


import AppGravarVisitaDialog from './dialogs/GravarVisitaDialog.vue';

import AppAdicionarContatosAdicionaisDialog from '../../shared/dialogs/AdicionarContatosAdicionaisDialog.vue'

import AppGravarRepresentanteDialog from '../../shared/dialogs/GravarRepresentanteDialog.vue';

import AppGravarContaDialog from './dialogs/GravarContaDialog.vue';

import AppGravarContatoRealizadoDialog from './dialogs/GravarContatoRealizadoDialog.vue';
import AppEditarContatoRealizadoDialog from './dialogs/EditarContatoRealizadoDialog.vue';

import AppGerarBoletosEmAbertoDialog from './dialogs/GerarBoletosEmAbertoDialog.vue';
import AppGerarDemonstrativoDialog from './dialogs/GerarDemonstrativoDialog.vue';
import AppGerarBoletoDialog from './dialogs/GerarBoletoDialog.vue';

import AppProrrogarBoletoDialog from './dialogs/ProrrogarBoletoDialog.vue'
import AppAlterarPeriodoReciboDialog from './dialogs/AlterarPeriodoReciboDialog.vue'
import AppPagarReciboDialog from './dialogs/PagarReciboDialog.vue';
import AppPagarValorEmAbertoDialog from './dialogs/PagarValorEmAbertoDialog.vue';
import AppLiberarRepasseDialog from './dialogs/LiberarRepasseDialog.vue';
import AppAlterarTaxaAdmDialog from './dialogs/AlterarTaxaAdmDialog.vue';
import AppGravarItemReciboDialog from './dialogs/GravarItemReciboDialog.vue';

import AppUploadArquivoDialog from '../../shared/dialogs/UploadArquivoDialog.vue';
import AppCriarDiretorioArquivoDialog from "../../shared/dialogs/CriarDiretorioArquivoDialog.vue";
import AppSelecionarDiretorioArquivoDialog from "../../shared/dialogs/SelecionarDiretorioArquivosDialog.vue"; 
import AppGravarObservacaoDialog from '../../shared/dialogs/GravarObservacaoDialog.vue';

import AppGravarRegistroCobrancaDialog from '../clientes/dialogs/GravarRegistroCobrancaDialog.vue'

import Util from '../../util/funcoes.js';
import { ESTADOS, ESTADO_CIVIL, STATUS_RECIBO_REPASSE, TIPO_ITEM_RECIBO, PERFIL_CLIENTE_ALUGUEL, OPERACAO_IMOVEL, STATUS_IMOVEL, FORMA_PAGAMENTO, FORMA_RECEBIMENTO, TIPOS_CONTATOS, EMAIL_REGEX, BANCOS, REGRA_REPASSE } from '../../util/constantes.js';
import { Money } from "v-money";

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFolder, faFile } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFolder, faFile)

export default {
  components: {
    AppGravarVisitaDialog,

    AppAdicionarContatosAdicionaisDialog,

    AppGravarRepresentanteDialog,

    AppGravarContaDialog,

    AppGravarContatoRealizadoDialog,
    AppEditarContatoRealizadoDialog,

    AppGerarBoletosEmAbertoDialog,
    AppGerarDemonstrativoDialog,
    AppGerarBoletoDialog,

    AppProrrogarBoletoDialog,
    AppAlterarPeriodoReciboDialog,
    AppPagarReciboDialog,
    AppPagarValorEmAbertoDialog,
    AppLiberarRepasseDialog,
    AppAlterarTaxaAdmDialog,
    AppGravarItemReciboDialog,

    AppUploadArquivoDialog,
    AppCriarDiretorioArquivoDialog,
    AppSelecionarDiretorioArquivoDialog,
    AppGravarObservacaoDialog,

    AppGravarRegistroCobrancaDialog,

    FontAwesomeIcon,
    Money
  },
  created() {
    if (this.clienteNovo) this.configurarCampoAtendente();
  },
  data() {
    return {
      infiniteLoadingId: 0,
      infiniteLoadingIdLog: 0,

      validacao: {
        nome: [
          { required: true, message: "Nome é obrigatório" },
        ],
        celular: [
          { required: true, message: "Telefone é obrigatório", validator: this.validadorTelefoneCelular },
        ],
        cpfCnpj: [
          { required: true, message: "CPF/CNPJ é obrigatório", validator: this.validadorCpfCnpj }
        ],
        email: [
          { required: true, validator: this.validarEmail },
        ],
      },

      // RESUMO
      imovelSelecionado: {
        id: null
      },
      contratoAtivo: undefined,

      //DIALOGS - CONTATO ADICIONAL
      visibilidadeAdicionarContatoAdicionalDilalog: false,

      contatoAlternativo: {},
      indexContatoAdicional: 0,

      //DIALOGS - CONTA BANCÁRIA
      visibilidadeGravarContaDialog: false,

      contaBancariaEmEdicao: {},

      loadingUsuarios: false,

      //DIALOGS - CONTATO REALIZADO
      visibilidadeGravarContatoRealizadoDialog: false,
      visibilidadeEditarContatoRealizadoDialog: false,

      visibilidadeGravarRepresentanteDialog: false,
      visibilidadeUploadArquivoDialog: false,
      visibilidadeGravarObservacaoDialog: false,
      visibilidadeGravarVisitaDialog: false,
      visibilidadePagarReciboDialog: false,
      visibilidadePagarValorEmAbertoDialog: false,
      visibilidadePagarReciboParcialmente: false,
      visibilidadeLiberarRepasseDialog: false,
      visibilidadeProrrogarBoletoDialog: false,
      visibilidadeAlterarTaxaAdmDialog: false,
      visibilidadeGravarItemReciboDialog: false,
      motivoFinalizacaoContato: undefined,

      //DIALOGS - RECIBOS/REPASSES
      visibilidadeGerarBoletosEmAbertoDialog: false,
      visibilidadeGerarDemonstrativoDialog: false,
      visibilidadeGerarBoletoDialog: false,
      visibilidadeGravarRegistroCobranca: false,
      visibilidadeAlterarPeriodoRecibo: false,

      visitaSelecionada: undefined,

      //ARQUIVOS
      visibilidadeCriarDiretorioDialogArquivo: false,
      visibilidadeSelecionarDiretorioArquivoDialog: false,

      arquivoSelecionado: undefined,
      arquivosProps: {
        label: "nome",
        children: "arquivos"
      },
      keysArquivo: ["usuario","descricao","data","localizacaoFisica", "extensao"],

      //Editar Contato
      contatoSelecionado: {},

      contatoRealizado: {
        dataProximoContato: undefined
      },
      dataProximoContato: "",

      //Editar Visita
      visita: {},
      horaVisita: "",
      dataVisita: "",
      imoveisVisita: {},

      //RECIBOS/REPASSES
      idContratoSelecionado: undefined,
      contratoSelecionado: undefined,

      recibosContratoSelecionado: [],
      reciboSelecionado: null,
      carenciaRepasseAtual: null,

      itensReciboSelecionado: [],
      pagamentosReciboSelecionado: [],
      pagamentoSelecionado: undefined,
      visualizarContratosAprovados: true,

      repasses: [
        {
          data: '11/07/2019',
          tipo: 'Crédito',
          descricao: 'Taxa de Administração',
          valor: 'R$ 2.000,00'
        },
      ],
      tabSelecionadaRecibos: 'itens',
      //Observação
      observacaoSelecionada: {},
      observacaoEmEdicao: undefined,
      filtroObservacoes: '',

      tabKey: 0,
      tabSelecionada: 'detalhes',
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      recibosDisponiveisParaGeracao: [],
      
      hoverGravar: false,
      hoverRemover: false,
      representanteRecuperado: undefined
    }
  },
  computed: {
    ...mapState('alugueisClientesStore', {
      clientes(state) { return state.listaClientes },
      clientePesquisa(state) { return state.clientePesquisa },
      labelQuantidade(state) { return state.labelQuantidade },

      cliente(state) { return state.clienteSelecionado },
      logs(state) { return state.logs },
      logPesquisa(state) { return state.logPesquisa },
      arquivos(state){ return state.clienteSelecionado.diretorios},

      usuariosDisponiveis(state) { return state.usuariosDisponiveis },

      carenciaRepasseExibida() {
          if (!this.recibosContratoSelecionado.length) return null;
          const aluguel = this.recibosContratoSelecionado[0].aluguel;
          if (!aluguel) return null;
      
          if (aluguel.regraRepasse === 'DIAS_CORRIDOS') {
              const retorno = this.carenciaRepasseAtual !== null 
                  ? this.carenciaRepasseAtual 
                  : aluguel.carenciaRepasse;
              return retorno;
          }
      
          return aluguel.carenciaRepasse;
      }
    }),
    ...mapState('loginStore', {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] },
      permissoesImoveisvenda(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "IMOVEIS_VENDA" })[0] }
    }),
    clienteNovo() {
      return this.cliente.id == 0
    },
    isPessoaFisica() {
      return this.cliente.personalidadeJuridica === 'PESSOA_FISICA';
    },
    isPessoaJuridica() {
      return this.cliente.personalidadeJuridica === 'PESSOA_JURIDICA';
    },

    estados() {
      return ESTADOS.filter(estado => { return estado.pais.id === 1 });
    },
    estadoCivil() {
      return ESTADO_CIVIL;
    },
    categoriasCliente() {
      return PERFIL_CLIENTE_ALUGUEL;
    },
    statusReciboRepasse() {
      return STATUS_RECIBO_REPASSE;
    },
    tipoItemRecibo() {
      return TIPO_ITEM_RECIBO
    },
    operacaoImovel() {
      return OPERACAO_IMOVEL
    },
    statusImovel() {
      return STATUS_IMOVEL
    },
    formasPagamento() {
      return FORMA_PAGAMENTO
    },
    formasRecebimento() {
      return FORMA_RECEBIMENTO
    },
    bancos() {
      return BANCOS
    },
    regrasRepasse() {
      return REGRA_REPASSE
    },
    disableRadio() {
      return this.cliente.id != 0
    },
    observacoes() {
      return this.cliente.observacoes
        .filter(this.filtrarObservacoes);
    },
    //CLIENTE
    exibirCamposPessoaFisica() {
      return this.cliente.personalidadeJuridica == "PESSOA_FISICA";
    },
    exibirCamposPessoaJuridica() {
      return this.cliente.personalidadeJuridica == "PESSOA_JURIDICA";
    },
    exibirCamposConjuge() {
      return this.cliente.personalidadeJuridica == "PESSOA_FISICA" && ['CASADO', 'UNIAO_ESTAVEL'].includes(this.cliente.estadoCivil);
    },
    desabilitarCampoAtendente() {
      return !this.permissoes.alteracaoCorretor;
    },

    //DETALHES
    exibirBotaoGravarCliente() {
      return ((this.permissoes.cadastro && this.cliente.id == 0) || (this.permissoes.alteracao && this.cliente.id != 0));
    },
    exibirBotaoRemoverCliente() {
      return (this.cliente.id != 0 && this.permissoes.remocao
      );
    },

    //CONTATOS REALIZADOS
    exibirBotaoNovoContato() {
      return this.tabSelecionada == "contatos"
    },
    exibirBotaoFinalizarContato() {
      return (
        this.tabSelecionada == "contatos" &&
        this.contatoSelecionado &&
        this.contatoSelecionado.id !== 0 &&
        this.contatoSelecionado.status === "EM_ANDAMENTO"
      );
    },

    //RECIBOS
    exibirTabHistoricoPagamentos(){
      return ( ( this.reciboSelecionado && this.reciboSelecionado.status === 'EM_ABERTO' ) ||
      ( this.pagamentosReciboSelecionado && this.pagamentosReciboSelecionado.length > 0 ) ) 
      && this.isLocatario
    },
    cabecalhoRecibosRepasses() {
      if (this.isProprietario) {
        return "Repasses do Proprietário"
      } else if (this.isLocatario) {
        return "Recibos do Locatário"
      } else if (this.isBeneficiario) {
        return "Repasses do Beneficiário"
      }
    },
    cabecalhoItensRecibosRepasses() {
      if (this.isProprietario || this.isBeneficiario) {
        return "Itens do Repasse"
      } else if (this.isLocatario) {
        return "Itens do Recibo"
      }
    },
    isLocatario() {
      if (this.contratoSelecionado != null) {
        return this.contratoSelecionado.imovel.nome.indexOf("LOCATARIO") != -1
      } else {
        return false
      }
    },
    isProprietario() {
      if (this.contratoSelecionado != null) {
        return this.contratoSelecionado.imovel.nome.indexOf("PROPRIETARIO") != -1
      } else {
        return false
      }
    },
    isBeneficiario() {
      if (this.contratoSelecionado != null) {
        return this.contratoSelecionado.imovel.nome.indexOf("BENEFICIARIO") != -1
      } else {
        return false
      }
    },
    categoriaCliente() {
      if (this.isLocatario) {
        return 'LOCATARIO'
      } else if (this.isProprietario) {
        return 'PROPRIETARIO'
      } else if (this.isBeneficiario) {
        return 'BENEFICIARIO'
      }
    },
    labelColRepasse() {
      carenciaRepasseAtual;
      if (this.contratoSelecionado != null && this.contratoSelecionado.regraRepasse === 'DIAS_CORRIDOS') {
        carenciaRepasseAtual = null
        return 'Repasse: Dias Corridos'
      } else {
        carenciaRepasseAtual = null
        return 'Repasse: Dia Fixo'
      }
    },
    exibirBotaoVerAprovados() {
      return this.tabSelecionada == "recibos" && !this.visualizarContratosAprovados
    },
    exibirBotaoVerFinalizados() {
      return this.tabSelecionada == "recibos" && this.visualizarContratosAprovados
    },
    exibirBotaoGerarDemonstrativos() {
      const quantidade = this.recibosContratoSelecionado.filter(item => item.status === 'PAGO').length;
      
      return this.recibosContratoSelecionado && quantidade > 0;
    },
    exibirBotaoPagarValorEmAberto(){
      return this.reciboSelecionado && this.reciboSelecionado.valorEmAberto > 0 && this.reciboSelecionado.dataPagamento;
    },
    exibirBotaoPagarParcial(){
      return this.reciboSelecionado && this.reciboSelecionado.status === 'EM_ABERTO' &&
      this.reciboSelecionado.dataPagamento === undefined && this.pagamentosReciboSelecionado.length === 0;
    },
    exibirBotaoCancelarPagamentoParcial(){
      return this.reciboSelecionado && this.pagamentoSelecionado;
    },
    classeBotaoVerFinalizados() {
      if(this.visualizarContratosAprovados) {
        return 'el-icon-refresh-left'
      } else {
        return 'el-icon-refresh-right'
      }
    },
    tamanhoSelecionarContrato(){
      return (this.exibirBotaoGerarBoletosEmAberto || 0) + (this.exibirBotaoGerarDemonstrativos || 0) + (this.exibirBotaoCobrarAluguel || 0) + 
      (this.exibirBotaoAlterarTaxaAdministracao || 0) + (this.exibirBotaoVerAprovados || 0) +
        (this.exibirBotaoVerFinalizados || 0) + (this.exibirBotaoAlterarPeriodoRecibo || 1) <= 4;
    },
    corBotaoVerFinalizados() {
      if(this.visualizarContratosAprovados) {
        return 'danger'
      } else {
        return 'success'
      }
    },
    contentTooltipBotaoVerFinalizados() {
      if(this.visualizarContratosAprovados) {
        return 'Ver Finalizados'
      } else {
        return 'Ver Aprovados'
      }
    },
    exibirBotaoAlterarTaxaAdministracao() {
      return this.contratoSelecionado && this.isProprietario
    },
    exibirBotaoAlterarPeriodoRecibo() {
      return this.usuarioLogado.imobiliaria.parametros.alterarPeriodoRecibos && this.reciboSelecionado && this.usuarioLogado.suporte;
    },
    exibirBotaoBloquearBaixa() {
      return this.contratoSelecionado && this.reciboSelecionado
        && this.reciboSelecionado.status == "EM_ABERTO" && !this.reciboSelecionado.baixaBloqueada
    },
    exibirBotaoDesbloquearBaixa() {
      return this.contratoSelecionado && this.reciboSelecionado
        && this.reciboSelecionado.status == "EM_ABERTO" && this.reciboSelecionado.baixaBloqueada
    },
    exibirBotaoCancelarRegistro(){
      return this.contratoSelecionado && this.reciboSelecionado && this.reciboSelecionado.dataRegistro && 
      this.reciboSelecionado.status === 'EM_ABERTO' && this.permissoes.cancelarRegistroRecibo;
    },
    exibirLabelMotivoBroqueioBaixa(){
      return this.contratoSelecionado && this.reciboSelecionado
        && this.reciboSelecionado.status == "EM_ABERTO" && this.reciboSelecionado.baixaBloqueada
    },
    exibir1viaGerada() {
      return this.contratoSelecionado
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && this.reciboSelecionado.via1Gerada
    },
    exibirBotaoPagarAluguel() {
      return this.contratoSelecionado && this.isLocatario
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && this.permissoes.pagarAluguel
    },
    exibirBotaoGerarDemonstrativo() {
      return this.reciboSelecionado
        && ((this.usuarioLogado.imobiliaria.parametros.gerarDemonstrativoAposBaixa && this.reciboSelecionado.status == "PAGO") || !this.usuarioLogado.imobiliaria.parametros.gerarDemonstrativoAposBaixa)
        && this.permissoes.gerarBoletos
    },
    exibirBotaoGerarBoleto() {
      return this.contratoSelecionado && this.isLocatario
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && this.permissoes.gerarBoletos
    },
    exibirBotaoGerarBoletosEmAberto() {
      return this.contratoSelecionado && this.isLocatario
        && this.permissoes.gerarBoletos
    },
    exibirBotaoProrrogarBoleto() {
      return this.contratoSelecionado && this.isLocatario
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && !this.reciboSelecionado.dataProrrogacao && this.permissoes.prorrogarBoleto
    },
    exibirBotaoCancelarPagamento() {
      return this.contratoSelecionado && this.isLocatario
        && this.reciboSelecionado && this.reciboSelecionado.status == "PAGO"
        && this.permissoes.cancelarAluguel
    },
    exibirBotaoCancelarPagamentoBeneficiario() {
      return this.contratoSelecionado && this.isBeneficiario
      && (this.reciboSelecionado && this.reciboSelecionado.reciboProprietario.id == 0) && this.reciboSelecionado.status == "PAGO"
    },
    exibirBotaoLiberarRepasse() {
      return this.contratoSelecionado && this.isProprietario
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && this.permissoes.liberarRepasse
    },
    exibirBotaoCancelarRepasse() {
      return this.contratoSelecionado && this.isProprietario
        && this.reciboSelecionado && this.reciboSelecionado.status == "PAGO"
        && this.permissoes.cancelarRepasse
    },
    exibirBotaoCancelarProrrogacao() {
      return this.contratoSelecionado && this.isLocatario
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && this.reciboSelecionado.dataProrrogacao && this.permissoes.prorrogarBoleto
    },
    exibirBotaoAdicionarItem() {
      return this.contratoSelecionado
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && ((this.permissoes.adicionarItemRecibo && this.isLocatario) || (this.permissoes.adicionarItemRepasse && this.isProprietario))
    },
    exibirBotaoCobrarAluguel() {
      return this.contratoSelecionado
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && this.reciboIsVencido()
        && this.categoriaCliente == 'LOCATARIO'
        && this.permissoes.registrarCobranca
    },
    somatorioItensRecibo() {
      let somatorio = 0;
      this.itensReciboSelecionado.forEach(item => {
        if (item.tipo === 'CREDITO') {
          somatorio -= item.valor;
        } else {
          somatorio += item.valor;
        }
      });

      return somatorio
    },
    somatorioItensRepasse() {
      let somatorio = 0;
      this.itensReciboSelecionado.forEach(item => {
        if (item.tipo === 'DEBITO') {
          somatorio -= item.valor;
        } else {
          somatorio += item.valor;
        }
      });

      return somatorio
    },
    exibirBotaoAdicionarPagamento(){
      return this.contratoSelecionado
      && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
    },

    //CONTAS BANCÁRIAS
    exibirBotaoNovaConta() {
      return (
        this.tabSelecionada == "contas" &&
        !this.permissoes.alteracaoClienteComExcecaoContaBancaria
      )
    },

    retornarPermissaoSelecionada() {
      
      if (!this.permissoes.alteracaoClienteComExcecaoContaBancaria) {
        return !this.permissoes.alteracaoClienteComExcecaoContaBancaria
      } 
    },

    //VISITAS
    exibirBotaoNovaVisita() {
      return this.tabSelecionada == "visitas"
    },

    //ARQUIVOS
    exibirBotaoUploadArquivo() {
      return this.tabSelecionada == "arquivos"
    },
    linhasArquivo(){
      if(this.arquivoSelecionado){
        return Object.entries(this.arquivoSelecionado)
        .filter(([key]) => this.keysArquivo.includes(key) )
        .map(([key,value]) => ({key, value})).sort((a, b ) => {
          if(a.key === "localizacaoFisica"){
            return 1
          }
          if(b.key === "localizacaoFisica"){
            return -1
          }
        })
      }      
    },

    perfisDisponiveis() {
      var auxSetPerfis = new Set();      
      var auxArrayPerfis = new Array();
      var auxPerfis = this.cliente.perfis.filter(item => {
        return item.imovel.operacao === 'ALUGUEL'
      });
      var auxObjPerfis, auxObjStatus;
      var i;
      
      for (i = 0; i < auxPerfis.length; i++) {
        auxSetPerfis.add(this.formatarString(auxPerfis[i].perfil.toString()));        
      }
      
      auxSetPerfis.forEach(function (value) {
        auxObjPerfis = new Object();
        auxObjPerfis["label"] = " " + value;
        auxObjPerfis["children"] = [];
        var auxSetStatus = new Set();

        auxPerfis.forEach(function (item) {
          if(item.perfil.toString().toLowerCase() == value.toLowerCase()){
            let str = item.imovel.status.toString();            
            auxSetStatus.add(str[0].toUpperCase() + str.substring(1).toLowerCase());
          }
        })

        auxSetStatus.forEach(function (valueStatus) {
          //Tratamento da label de status do imovel
          let str = valueStatus.split('_');
          for (var i = 0, x = str.length; i < x; i++) {
           str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
          }

          auxObjStatus = new Object();
          auxObjStatus["perfil"] = value;
          //definir label status do imovel
          auxObjStatus["label"] = " " + str.join(" ");
          auxObjStatus["children"] = [];

          auxPerfis.forEach(function (item) {
            if(item.perfil.toString().toLowerCase() == value.toLowerCase() && item.imovel.status.toString().toLowerCase() == valueStatus.toLowerCase()){
              auxObjStatus["children"].push(item.imovel);
            }
          })
          auxObjPerfis["children"].push(auxObjStatus)
        });

        auxArrayPerfis.push(auxObjPerfis);
      });
      return auxArrayPerfis;
    },

    // UTIL
    maskCpfCnpj() {
      if (this.cliente.personalidadeJuridica === 'PESSOA_FISICA') {
        return '###.###.###-##'
      } else {
        return '##.###.###/####-##'
      }
    },
    isEnviadoParaJuridico() {
      if(this.contratoSelecionado) {
        return this.contratoSelecionado.enviadoParaJuridico
      } else {
        return false;
      }
    },
    exibirAlertaCpfInvalido(){
      return !Util.validarCpf(this.cliente.cpfCnpj) && this.cliente.cpfCnpj.length === 14;
    }
  },
  watch: {
    clienteNovo(newValue) {
      if (newValue) {
        if (this.tabSelecionada !== "detalhes") {
          this.tabSelecionada = "detalhes"
          this.tabKey++;
        }
      }
    },
    'cliente.id': function (newValue, oldValue) {
      if (newValue != oldValue) {
        if (this.tabSelecionada !== "detalhes") {
          this.tabSelecionada = "detalhes";
        }
        this.idContratoSelecionado = (this.cliente.contratosAluguel && this.cliente.contratosAluguel.length > 0 ? this.cliente.contratosAluguel[0].id : undefined)

        const contratos = [...this.cliente.contratosAluguel, ...this.cliente.contratosFinalizados];
        const byId = contrato => contrato.id === this.idContratoSelecionado;
        this.contratoSelecionado = contratos.filter(byId)[0];

        this.limparReciboSelecionado();
        this.imovel = {
          id: 0,
          perfil: "",
          endereco: "",
          numeroEndereco: "",
          operacao: "",
          bairro: {
            cidade: "",
            nome: "",
            zona: "",
          }
        }

        this.limparContatoRealizado()
        this.observacaoSelecionada = {};
        this.pagamentosReciboSelecionado = []
        this.pagamentoSelecionado = undefined
      }
    },
    idContratoSelecionado(newValue) {
      if (!newValue) {
        this.contratoSelecionado = undefined
        this.recibosContratoSelecionado = []
        this.itensReciboSelecionado = []
        this.pagamentosReciboSelecionado = []
        this.pagamentoSelecionado = undefined
        this.tabSelecionadaRecibos = 'itens'
        return
      }

      this.contratoSelecionado = this.cliente.contratosAluguel.concat(this.cliente.contratosFinalizados).filter((contrato) => { return contrato.id == newValue })[0]
      this.recibosContratoSelecionado = []
      this.itensReciboSelecionado = []
      this.pagamentosReciboSelecionado = []
      this.pagamentoSelecionado = undefined

      this.recuperarContratoSelecionadoHandler()

      this.limparReciboSelecionado();
    },
    recibosContratoSelecionado(newList) {
      if (this.reciboSelecionado) {
        newList.forEach(item => {
          if (this.reciboSelecionado.id === item.id) {
            this.reciboSelecionado = item
            this.itensReciboSelecionado = item.itensRecibo
            this.pagamentosReciboSelecionado = item.pagamentosRecibo
          }
        });
      }
      this.pagamentoSelecionado = undefined
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
      'novoCliente',
      'limparClientePesquisa',
      'limparClientesListados',
      'pesquisarClientes',
      'recuperarClienteAluguel',
      'gravarCliente',
      'reativarCliente',
      'removerCliente',

      'listarUsuarios',

      'gravarContatoRealizado',
      'atualizarContatoRealizado',
      'removerContatoRealizado',

      'gravarConta',
      'removerConta',
      'removerContaComRepasse',

      'listarRecibosContratoCliente',
      'bloquearBaixa',
      'desbloquearBaixa',
      'cancelarPagamento',
      'cancelarPagamentoParcial',
      'cancelarProrrogacao',
      'cancelarRegistro',
      'cancelarRepasse',
      'removerItemRecibo',

      'gravarVisita',
      'recuperarVisita',
      'removerVisita',

      'recuperarLogs',
      'limparLogPesquisa',

      'recuperarObservacaoCliente',
      'removerObservacao',

      'removerArquivo',
      'removerArquivo',
      'removerDiretorioArquivos',
      'cancelarPagamentoBeneficiario',
      'gerarTodosDemonstrativosRepasse',
      'gerarReciboPagamento'
    ]),
    ...mapActions('alugueisImoveisStore',
      { recuperarImovelAluguel: 'recuperarImovel' }
    ),
    ...mapActions('alugueisImoveisStore', [
      'recuperarAluguelAtivo'
    ]),
    ...mapActions('vendasImoveisStore', {
      recuperarImovelVenda: 'recuperarImovel'
    }),

    reciboIsVencido() {
      if(this.reciboSelecionado && this.reciboSelecionado.dataProrrogacao) {
        if(Util.compararDatas(this.reciboSelecionado.dataProrrogacao, Util.hoje()) == -1) {
          return true;
        } else {
          return false;
        }
      } else if(this.reciboSelecionado && this.reciboSelecionado.dataVencimento) {
        if(Util.compararDatas(this.reciboSelecionado.dataVencimento, Util.hoje()) == -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    configurarCampoAtendente() {
      this.cliente.usuario = this.usuarioLogado;

      const usuarioLogadoNotInUsuariosDisponiveis = !this.usuariosDisponiveis.map(usuario => usuario.id)
        .includes(this.usuarioLogado.id);

      if (usuarioLogadoNotInUsuariosDisponiveis) {
        this.usuariosDisponiveis.push(this.usuarioLogado);
      }
    },
    novoClienteHandler() {
      this.novoCliente();
      this.configurarCampoAtendente();
    },
    pesquisarHandler() {
      this.clientePesquisa.pagina = 0;
      this.limparClientesListados();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if (this.permissoes.visualizacaoSomenteClientesCorretor) {
        this.clientePesquisa.usuario = { id: this.usuarioLogado.id }
      }
      if (this.clientePesquisa.pagina == 0) { this.showLoading(); }

      this.pesquisarClientes(this.clientePesquisa)
        .then((resultado) => {
          if (this.clientePesquisa.pagina == 0) { this.hideLoading(); }

          if (resultado.lista.length == 100) {
            this.clientePesquisa.pagina += 1;
            $state.loaded();
          } else if (resultado.lista.length > 0 && this.clientePesquisa.pagina == 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        });
    },
    recuperarHandler(cliente) {
      this.recuperar(cliente);
    },
    recuperar(cliente) {
      this.irParaSecao()
      const payload = { id: cliente.id };
      this.showLoading();

      this.recuperarClienteAluguel(payload)
        .then((resultado) => {
          switch (resultado.status) {
            case "SUCESSO":
            case "FALHA":
            case "ERRO":
              this.hideLoading();
              break;
          }
        });
    },

    validadorTelefoneCelular(rule, value, callback) {
      if (value) {
        return callback();
      } else {
        if (this.cliente.telefone) {
          return callback();
        } else {
          return callback(new Error());
        }
      }
    },

    cpfIsValido(cpf) {
      return Util.validarCpf(cpf);
    },

    cnpjIsValido(cnpj) {
      if (!cnpj) return false;

      return cnpj.length === 18;
    },

    validadorCpfCnpj(rule, value, callback) {
      if (this.cliente.personalidadeJuridica === 'PESSOA_FISICA') {
        if (this.cpfIsValido(value)) {
          return callback();
        } else {
          return callback(new Error());
        }
      } else {
        if (this.cnpjIsValido(value)) {
          return callback();
        } else {
          return callback(new Error());
        }
      }
    },

    validarEmail(rule, value, callback) {
      const emailPattern = EMAIL_REGEX;

      if(!value || value.trim() === '') {
        return callback();
      }

      if(emailPattern.test(value)) {
        return callback();
      }

      return callback(new Error());
    },

    gravarHandler() {
      this.$refs['form'].validate(isValid => {
        const pessoaJuridicaSemRepresentantes = isValid
          && this.cliente.personalidadeJuridica === 'PESSOA_JURIDICA'
          && this.cliente.representantes.length === 0;

        if (pessoaJuridicaSemRepresentantes) {
          this.exibirAlert('Atenção', 'Você deve cadastrar ao menos um representante da pessoa jurídica');
          return;
        }

        if(this.validarCpfCnpj()) {
          this.exibirAlert('Atenção', 'O cpf/cnpj informado é invalido!');
          return;
        }

        const formIsNotValid = !isValid;
        if (formIsNotValid) {
          this.exibirAlert('Atenção', 'Preencha todos os campos obrigatórios');
          return;
        }

        this.gravar();
      });
    },

    validarCpfCnpj() {
      if(this.cpfIsValido(this.cliente.cpfCnpj)) {
        return false;
      }

      if(this.cnpjIsValido(this.cliente.cpfCnpj)) {
        return false;
      }

      return true;
    },

    getPayloadGravarCliente() {
      if(this.isPessoaFisica) return this.getPayloadGravarClientePessoaFisica();
      if(this.isPessoaJuridica) return this.getPayloadGravarClientePessoaJuridica();
    },

    getPayloadGravarClientePessoaFisica() {
      return {
        id: this.cliente.id,
        versao: this.cliente.versao,
        imobiliaria: this.cliente.imobiliaria,
        extratoRendimentoPortalCliente: this.cliente.extratoRendimentoPortalCliente,
        idNaImobiliaria: this.cliente.idNaImobiliaria,
        personalidadeJuridica: this.cliente.personalidadeJuridica,
        nome: this.cliente.nome,
        cpfCnpj: this.cliente.cpfCnpj,
        rg: this.cliente.rg,
        dataNascimento: this.cliente.dataNascimento,
        estadoCivil: this.cliente.estadoCivil,
        sexo: this.cliente.sexo,
        nacionalidade: this.cliente.nacionalidade,
        profissao: this.cliente.profissao,
        rendaMensal: this.cliente.rendaMensal,
        celular: this.cliente.celular,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        usuario: this.cliente.usuario,
        endereco: this.cliente.endereco,
        numeroEndereco: this.cliente.numeroEndereco,
        complemento: this.cliente.complemento,
        cep: this.cliente.cep,
        estado: this.cliente.estado,
        cidade: this.cliente.cidade,
        bairro: this.cliente.bairro,
        enderecoComercial: this.cliente.enderecoComercial,
        numeroEnderecoComercial: this.cliente.numeroEnderecoComercial,
        complementoComercial: this.cliente.complementoComercial,
        cepComercial: this.cliente.cepComercial,
        estadoComercial: this.cliente.estadoComercial,
        cidadeComercial: this.cliente.cidadeComercial,
        bairroComercial: this.cliente.bairroComercial,
        nomeConjuge: this.cliente.nomeConjuge,
        cpfConjuge: this.cliente.cpfConjuge,
        rgConjuge: this.cliente.rgConjuge,
        emailConjuge: this.cliente.emailConjuge,
        profissaoConjuge: this.cliente.profissaoConjuge,
        nacionalidadeConjuge: this.cliente.nacionalidadeConjuge,
        contatosAlternativos: this.cliente.contatosAlternativos,
        contatosRealizados: this.cliente.contatosRealizados,
        arquivos: this.cliente.arquivos,
        visitas: this.cliente.visitas,
      };
    },

    getPayloadGravarClientePessoaJuridica() {
      return {
        id: this.cliente.id,
        versao: this.cliente.versao,
        imobiliaria: this.cliente.imobiliaria,
        extratoRendimentoPortalCliente: this.cliente.extratoRendimentoPortalCliente,
        idNaImobiliaria: this.cliente.idNaImobiliaria,
        personalidadeJuridica: this.cliente.personalidadeJuridica,
        nome: this.cliente.nome,
        cpfCnpj: this.cliente.cpfCnpj,
        celular: this.cliente.celular,
        telefone: this.cliente.telefone,
        email: this.cliente.email,
        usuario: this.cliente.usuario,
        endereco: this.cliente.endereco,
        numeroEndereco: this.cliente.numeroEndereco,
        complemento: this.cliente.complemento,
        cep: this.cliente.cep,
        estado: this.cliente.estado,
        cidade: this.cliente.cidade,
        bairro: this.cliente.bairro,
        enderecoComercial: this.cliente.enderecoComercial,
        numeroEnderecoComercial: this.cliente.numeroEnderecoComercial,
        complementoComercial: this.cliente.complementoComercial,
        cepComercial: this.cliente.cepComercial,
        estadoComercial: this.cliente.estadoComercial,
        cidadeComercial: this.cliente.cidadeComercial,
        bairroComercial: this.cliente.bairroComercial,
        representantes: this.cliente.representantes,
        contatosAlternativos: this.cliente.contatosAlternativos,
        contatosRealizados: this.cliente.contatosRealizados,
        arquivos: this.cliente.arquivos,
        visitas: this.cliente.visitas,
      };
    },

    gravar() {
      const payload = this.getPayloadGravarCliente();
      this.showLoading();

      this.gravarCliente(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.pesquisarHandler();
              break;
            case "FALHA":
              if (resultado.mensagem.includes('reativá-lo')) {
                this.reativarClienteHandler(resultado.mensagem)
              } else {
                this.$message.warning(resultado.mensagem);
              }
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se com o servidor");
        });
    },
    reativarClienteHandler(mensagem) {
      this.$confirm(mensagem, 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.reativar();
      });
    },
    reativar() {
      this.showLoading();
      this.reativarCliente(this.cliente).then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      });
    },
    removerClienteHandler() {
      this.$confirm('Deseja realmente remover este cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      const payload = {
        id: this.cliente.id,
        nome: this.cliente.nome
      }
      this.removerCliente(payload).then(resultado => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      });
    },
    // HELPER FUNCTIONS
    selecionarImovel(node) {
      this.imovelSelecionado = node

      if (this.imovelSelecionado.status === 'LOCADO') {
        this.recuperarContratoAtivo();
      } else {
        this.contratoAtivo = undefined
      }
    },

    recuperarContratoAtivo() {
      this.recuperarAluguelAtivo(this.imovelSelecionado)
        .then(resultado => {
          if (resultado.status === 'SUCESSO') {
            this.contratoAtivo = resultado.item
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    recuperarImovelSelecionado(node) {
      if(this.permissoesImoveisvenda.visualizacao === false && node.data.operacao == 'VENDA') {
        this.$message.warning('Este usuário não tem permissão para acessar imóveis de venda!')
        return
      }

      this.imovelSelecionado = node.data
      let payload = { id: this.imovelSelecionado.id };

      if (node.data.operacao === 'ALUGUEL') {
        this.recuperarImovelAluguelHandler(payload)
      } else {
        this.recuperarImovelVendaHandler(payload)
      }
    },

    recuperarImovelAluguelHandler(payload) {
      this.showLoading();
      this.recuperarImovelAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            this.$router.push("/alugueis/imoveis");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
    },

    recuperarImovelVendaHandler(payload) {
      this.showLoading();
      this.recuperarImovelVenda(payload)
        .then(resultado => {
          this.hideLoading();
          if (resultado.status == "SUCESSO") {
            this.$router.push("/imoveis");
          }
          this.hideLoading();
        })
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.hideLoading();
        });
    },

    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    pesquisarLogs($state) {
      if (this.logPesquisa.pagina == 0) { this.showLoading(); }
      this.logPesquisa.cliente = { id: this.cliente.id }
      this.recuperarLogs(this.logPesquisa)
        .then((resultado) => {
          if (this.logPesquisa.pagina == 0) { this.hideLoading(); }

          if (resultado.lista.length == 100) {
            this.logPesquisa.pagina += 1;
            $state.loaded();
          } else if (resultado.lista.length > 0 && this.logPesquisa.pagina == 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        });
    },
    tabClicked(tab) {
      if (tab.name == "logs") {
        this.limparLogPesquisa();
        this.infiniteLoadingIdLog += 1;
        let payload = { cliente: { id: this.cliente.id }, pagina: 0 }

        this.recuperarLogs(payload).catch(() => {
          this.$message.error("Não foi possível recuperar os logs deste cliente");
        });
      }
      if (tab.name != "contatos") {
        this.limparContatoRealizado()
      }
    },
    haveContaBancaria(row){
      return row.formaRecebimento === 'BOLETO' || row.formaRecebimento === 'TRANSFERENCIA_BANCARIA' || 
      row.formaPagamento === 'DEPOSITO_EM_CONTA' || row.formaPagamento === 'PAGAMENTO_PIX';
    },
    getLabelReciboPagoTooltip(row){
      return this.getLabel(this.formasRecebimento, row.formaRecebimento) + 
      `${this.haveContaBancaria(row) ? ": " + (row.contaBancaria.banco ? 
        this.getLabel(this.bancos, row.contaBancaria.banco): this.getLabel(this.bancos, row.aluguel.contaBancariaImobiliaria.banco)) : ''}`;
    },
    getLabelRepassePagoTooltip(row){
      return this.getLabel(this.formasPagamento, row.formaPagamento) + 
      `${this.haveContaBancaria(row) ? ": " + (row.contaBancaria.banco ? 
        this.getLabel(this.bancos, row.contaBancaria.banco): this.getLabel(this.bancos, row.aluguel.contaBancariaImobiliaria.banco)) : ''}`;
    },
    getLabel(array, element) {
      return Util.getLabel(array, element);
    },
    formatarValor(valor) {
      return Util.formatarValor((valor < 0.1) && (valor > 0) ? 0 : valor)
    },
    formatarValorEmAberto(row){
      return row.status === 'PAGO' ? 'R$ 0,00' : ( row.valorEmAberto === undefined ? Util.formatarValor(row.valor) : Util.formatarValor(row.valorEmAberto));
    },
    limparPesquisa() {
      this.limparClientePesquisa();
    },
    formatarString(str) {
      
      str = str.split('_');
      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1).toLowerCase();
      }
      return str.join(" ");
    },

    // DETALHES - Contato Adicional
    exibirGravarContatoAdicionalDialog() {
      this.visibilidadeGravarContatoAdicionalDialog = true
    },
    fecharGravarContatoAdicionalDialog() {
      this.visibilidadeGravarContatoAdicionalDialog = false;
    },

    //SELECT
    filtrarUsuariosSelect(queryString) {
      if (queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString }
      this.loadingUsuarios = true;
      this.listarUsuarios(payload)
        .then(() => {
          this.loadingUsuarios = false;
        })
    },

    //CONTATOS REALIZADOS
    atualizaContato(contato) {
      this.contatoSelecionado = contato;
    },
    handlerFinalizarContato(){
      this.$prompt("Motivo da Finalização", "Atenção", {
        confirmButtonText: 'Finalizar',
        cancelButtonText: 'Cancelar'
      }).then(({ value }) => {      
        if(value === null){value = "Não Informado"}
        this.motivoFinalizacaoContato = value
        this.finalizarContatoRealizado();
      })
    },
    coresStatusContatoRealizado(status) {
      switch(status) {
        case "CONCLUIDO":
          return "#2DB748";
        case "EM_ANDAMENTO":
          return "#FF9E29";
      }
    },

    finalizarContatoRealizado() {
      this.$confirm('Deseja realmente finalizar este contato com o cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let auxContato = {
          status: "CONCLUIDO",
          id: this.contatoSelecionado.id,
          descricao: this.contatoSelecionado.descricao,
          cliente: {
            id: this.cliente.id
          },
          assunto: this.contatoSelecionado.assunto,
          motivoFinalizacao: this.motivoFinalizacaoContato 
        };
        this.showLoading();
        this.atualizarContatoRealizado(auxContato)
          .then((resultado) => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
      })
    },
    removerContatoHandler(contatoRealizado) {
      this.$confirm('Deseja realmente remover este contato com o cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerContato(contatoRealizado);
      }).catch(() => { });
    },
    removerContato(contatoRealizado) {
      this.showLoading();
      this.removerContatoRealizado(contatoRealizado)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.contatoSelecionado = {};
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
    },
    exibirGravarContatoRealizadoDialog(tipo) {
      if (tipo && tipo === 'NOVO') {
        this.contatoSelecionado = {}
        this.visibilidadeGravarContatoRealizadoDialog = true
      } else {
        //if (this.contatoSelecionado.status === 'CONCLUIDO') {
          //this.$message.warning("Não é possível editar contato concluído!");
        //} else {
          this.visibilidadeGravarContatoRealizadoDialog = true
        //}
      }

    },
    fecharEditarContatoRealizadoDialog() {
      this.visibilidadeEditarContatoRealizadoDialog = false;
    },
    exibirEditarContatoRealizadoDialog() {
      this.visibilidadeEditarContatoRealizadoDialog = true
    },
    fecharGravarContatoRealizadoDialog() {
      this.visibilidadeGravarContatoRealizadoDialog = false;
    },
    exibirGravarRepresentanteDialog() {
      this.visibilidadeGravarRepresentanteDialog = true
    },
    fecharGravarRepresentanteDialog(args) {
      this.representanteRecuperado = undefined
      if (args.representante) {
        this.cliente.representantes.push(args.representante);
      } else if(args.isRecuperarCliente) {
        this.recuperarClienteAluguel({ id: this.cliente.id })
      }

      this.visibilidadeGravarRepresentanteDialog = false;
    },
    exibirEditarRepresentanteDialog(representante) {
      this.representanteRecuperado = Object.assign({}, representante);

      this.visibilidadeGravarRepresentanteDialog = true;
    },
    limparContatoRealizado() {
      this.contatoSelecionado = {};
      this.contatoRealizado = {};
    },
    removerRepresentante(representante) {
      this.$confirm('Deseja remover este Representante?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.cliente.representantes = this.cliente.representantes.filter((elemento) => { return elemento != representante });
      }).catch(() => { });
    },
    removerContatoAdicional(contato) {
      this.$confirm('Deseja remover este Contato Adicional?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.cliente.contatosAlternativos = this.cliente.contatosAlternativos.filter((elemento) => { return elemento != contato });
      }).catch(() => { });

    },

    // CONTAS
    removerContaBancariaHandler(conta) {
      this.$confirm('Deseja realmente remover esta conta bancária do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerContaBancaria(conta);
      }).catch(() => { });
    },
    removerContaBancaria(conta) {
      this.showLoading();
      let payload = {
        id: conta.id
      }
      this.removerConta(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
              if (resultado.mensagem.includes("Deseja remover mesmo assim?")) {
                this.$confirm(resultado.mensagem, 'Atenção', {
                  confirmButtonText: 'Confirmar',
                  cancelButtonText: 'Cancelar',
                  type: 'warning'
                }).then(() => {
                  this.removerContaBancariaComRepasse(payload);
                }).catch(() => { });
              } else {
                this.$message.warning(resultado.mensagem);
              }
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
    },
    removerContaBancariaComRepasse(conta) {
      this.showLoading();
      this.removerContaComRepasse(conta)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
    },
    editarContaBancaria(conta) {
      const usuarioPodeEditarConta = !this.permissoes.alteracaoClienteComExcecaoContaBancaria;
      if (usuarioPodeEditarConta) {
        this.contaBancariaEmEdicao = Object.assign({}, conta);
        this.showLoading();
        this.visibilidadeGravarContaDialog = true;
        this.hideLoading();
      }
    },
    exibirGravarContaDialog() {
      this.contaBancariaEmEdicao = undefined;
      this.visibilidadeGravarContaDialog = true
    },
    fecharGravarContaDialog() {
      this.visibilidadeGravarContaDialog = false;
    },

    //RECIBOS/REPASSES
    pagarReciboHandler(){
      this.reciboSelecionado.dataPagamento ? this.exibirAlert('Atenção, Recibo pago parcialmente', 'Por favor, verifique o Histórico de Pagamentos') 
      : this.exibirPagarReciboDialog();
    },
    exibirBotaoRemoverItem(row) { 
      return this.contratoSelecionado
        && this.reciboSelecionado && this.reciboSelecionado.status == "EM_ABERTO"
        && ((this.permissoes.removerItemRecibo && this.isLocatario) || (this.permissoes.removerItemRepasse && this.isProprietario)) &&
        (row.categoria === "OUTROS" || row.categoria === "PDG" || row.categoria === "IRRF" || row.categoria === "IPTU" || row.categoria === "REFORMA" || row.categoria === "VALOR_EXTRA"
        || row.categoria === "TAXA_MANUTENCAO" || row.categoria === 'TAXA_DESOCUPACAO' || row.categoria === 'RESCISAO_CONTRATUAL' )
    },
    bloquearBaixaHandler() {
      if (this.isProprietario || this.isLocatario) {
        this.$prompt("Motivo do Bloqueio", "Atenção", {
          confirmButtonText: 'Bloquear',
          cancelButtonText: 'Cancelar'
        }).then(({ value }) => {
          this.showLoading();
          if(value === null){value = "Não Informado"}
          this.bloquearBaixa({ id: this.reciboSelecionado.id, motivoBloqueio: value })
            .then((resultado) => {
              this.hideLoading();
              switch (resultado.status) {
                case "SUCESSO":
                  this.recibosContratoSelecionado = resultado.lista
                  break;
              }
            }).catch(() => {
              this.hideLoading();
            });
        }).catch(() => {
          return
        });
      } else {
        this.showLoading();
        this.bloquearBaixa({ id: this.reciboSelecionado.id })
          .then((resultado) => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.recibosContratoSelecionado = resultado.lista
                break;
            }
          }).catch(() => {
            this.hideLoading();
          });
      }
    },
    desbloquearBaixaHandler() {
      this.showLoading();
      this.desbloquearBaixa({ id: this.reciboSelecionado.id })
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.recibosContratoSelecionado = resultado.lista
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },
    recuperarContratoSelecionadoHandler() {
      let payload = {
        aluguel: { id: this.contratoSelecionado.id },
        cliente: { id: this.cliente.id }
      }

      this.showLoading();
      this.listarRecibosContratoCliente(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.recibosContratoSelecionado = resultado.lista
              this.tabSelecionadaRecibos = 'itens'
              this.pagamentoSelecionado = undefined
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },
    reciboSelecionadoHandler(row) {
        this.reciboSelecionado = {...row, reciboLocatarioContratoFinalizado: this.isLocatario}
        this.carenciaRepasseAtual = row.carenciaRepasse !== undefined ? row.carenciaRepasse : null
                
        this.itensReciboSelecionado = row.itensRecibo
        this.pagamentosReciboSelecionado = row.pagamentosRecibo
        this.pagamentoSelecionado = undefined
        this.tabSelecionadaRecibos = 'itens'
        this.pagamentoSelecionado = undefined
    },
    atualizarPagamentoSelecionado(row){
      this.pagamentoSelecionado = row;
    },

    //CANCELAR REGISTRO DO RECIBO SELECIONADO
    handlerCancelarRegistro(){
      this.$confirm('O cancelamento do registro do boleto é irreversível, pois será gerado um novo número de recibo. Não haverá a baixa automática pelo arquivo de retorno.', 'Atenção', {
        confirmButtonText: 'Ok, estou ciente dos riscos',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.cancelarRegistroSelecionado();
      })
    },
    cancelarRegistroSelecionado(){
      this.showLoading();
      this.cancelarRegistro({ id: this.reciboSelecionado.id })
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.recibosContratoSelecionado = resultado.lista
              break;
            default:
              this.$message.warning(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },

    //PRORROGAÇÃO
    handlerCancelarProrrogacao(){
      this.$confirm('Tem certeza que deseja cancelar a prorrogação deste boleto?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.cancelarProrrogacaoBoleto()
      })
    },
    cancelarProrrogacaoBoleto() {
      this.showLoading();
      this.cancelarProrrogacao({ id: this.reciboSelecionado.id })
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.recibosContratoSelecionado = resultado.lista
              break;
            default:
              this.$message.warning(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },
    cancelarPagamentoHandler() {
      if(this.reciboSelecionado.pagamentosRecibo.length <= 1 ){
        this.$confirm('Tem certeza que deseja cancelar o pagamento deste aluguel?', 'Atenção', {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.cancelarPagamentoBoleto()
        })
      }else{
        this.exibirAlert("Recibo Pago Parcialmente ", "Por favor, verifique o 'Histórico de Pagamentos'")        
      }
      
    },
    cancelarPagamentoBoleto() {
      this.showLoading();
      this.cancelarPagamento({ id: this.reciboSelecionado.id })
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.recibosContratoSelecionado = resultado.lista
              break;
            default:
              if (resultado.mensagem.includes("sucesso")) {
                this.$message.success(resultado.mensagem);
                this.recibosContratoSelecionado = resultado.lista
              } else {
                this.$message.warning(resultado.mensagem);
              }
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },
    cancelarPagamentoParcialHandler() {
      if(this.pagamentosReciboSelecionado.length > 1){
        this.$confirm('Tem certeza que deseja cancelar este pagamento parcial?', 'Atenção', {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.cancelarPagamentos()     
        })
      }else{
        this.cancelarPagamentoHandler();    
      }
      
    },
    cancelarPagamentos() {
      this.showLoading();
      this.cancelarPagamentoParcial({
        ...this.pagamentoSelecionado,
        recibo:{
          id: this.reciboSelecionado.id
        }
      })
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.recibosContratoSelecionado = resultado.lista
              break;
            default:
              if (resultado.mensagem.includes("sucesso")) {
                this.$message.success(resultado.mensagem);
                this.recibosContratoSelecionado = resultado.lista
              } else {
                this.$message.warning(resultado.mensagem);
              }
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },
    cancelarRepasseHandler() {
      this.$confirm('Tem certeza que deseja cancelar este repasse?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.cancelarRepasseAluguel()
      })
    },
    cancelarRepasseAluguel() {
      this.showLoading();
      this.cancelarRepasse({ id: this.reciboSelecionado.id })
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.recibosContratoSelecionado = resultado.lista
              break;
            default:
              this.$message.warning(resultado.mensagem);
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },

    cancelarPagamentoBeneficiarioHandler() {
      this.$confirm('Tem certeza que deseja cancelar este pagamento?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.cancelarPagamentoBeneficiarioManual();
      })
    },

    cancelarPagamentoBeneficiarioManual() {
      this.showLoading();
      this.cancelarPagamentoBeneficiario({ id: this.reciboSelecionado.id })
      .then((resultado) => {
        this.hideLoading();
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.recibosContratoSelecionado = resultado.lista
            break;
          default:
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      })
    },

    removerItemReciboHandler(itemRecibo) {
      this.$confirm('Tem certeza que deseja remover este item?', 'Atenção', {
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(() => {
        this.showLoading();
        this.removerItemRecibo({ id: itemRecibo.id, recibo: { id: this.reciboSelecionado.id } })
          .then((resultado) => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.recibosContratoSelecionado = resultado.lista
                break;
              default:
                this.$message.warning(resultado.mensagem);
                break;
            }
          }).catch(() => {
            this.hideLoading();
          });
      })
    },

    limparReciboSelecionado() {
      this.reciboSelecionado = undefined;
    },
    // OBSERVAÇÕES
    filtrarObservacoes(observacao) {
      const descricao = observacao.descricao !== null ? Util.removerAcentos(observacao.descricao.trim().toLowerCase()) : '';
      const assunto = observacao.assunto !== null ? Util.removerAcentos(observacao.assunto.trim().toLowerCase()) : '';
      
      const searchTerm = Util.removerAcentos(this.filtroObservacoes.trim().toLowerCase());

      return descricao.includes(searchTerm) || assunto.includes(searchTerm);
    },
    
    exibirColunaRemoverObservacao() {
      return (this.permissoes.removerObservacoes);
    },
    removerObservacaoHandler(observacao) {
      this.$confirm('Deseja realmente remover esta observação do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let payload = { id: observacao.id }
        this.showLoading();
        this.removerObservacao(payload)
          .then((resultado) => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.observacaoSelecionada = {}
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
      })
    },
    alterarObservacao(observacao, column) {
      if (column.columnKey == "acoes") { return }
      if (!this.permissoes.alterarObservacoes) { return }
      if (this.permissoes.alterarObservacoesSomenteCorretor && observacao.usuario.id !== this.usuarioLogado.id) { return }

      let payload = { id: observacao.id };

      this.showLoading();
      this.recuperarObservacaoCliente(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.observacaoEmEdicao = resultado.item;
              this.observacaoSelecionada = {};
              this.visibilidadeGravarObservacaoDialog = true;
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },
    exibirGravarObservacaoDialog() {
      this.observacaoEmEdicao = undefined
      this.visibilidadeGravarObservacaoDialog = true;
    },
    fecharGravarObservacaoDialog() {
      this.visibilidadeGravarObservacaoDialog = false;
    },

    // ARQUIVOS
    removerArquivoHandler(arquivo) {
      this.$confirm('Deseja realmente remover este arquivo do cliente?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        let payload = { id: arquivo.id };
        this.showLoading();
        this.removerArquivo(payload)
          .then((resultado) => {
            this.hideLoading();
            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                break;
              case "FALHA":
              case "ERROR":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
      })
    },
    downloadArquivoHandler(arquivo) {
      window.open(arquivo.path, "_blank");
    },
    exibirDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = true
    },
    fecharDialogUploadArquivo() {
      this.visibilidadeUploadArquivoDialog = false;
    },
    exibirDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = true;
    },
    fecharDialogSelecionarDiretorioArquivo() {
      this.visibilidadeSelecionarDiretorioArquivoDialog = false;
    },
    exibirBotaoRemoverDiretorioArquivo(data) {
      return data.nome !== "Outros";
    },
    selecionarArquivo(arquivoSelecionado) {
      if(arquivoSelecionado !== undefined && arquivoSelecionado.descricao !== null) {
        this.arquivoSelecionado = arquivoSelecionado;
      }
    },
    labelPropriedades(key){
      switch (key) {
        case "usuario":
          return "Usuário";
        case "data":
          return "Envio";
        case "localizacaoFisica":
          return "Observações";    
        case "descricao":
          return "Nome";
        case "extensao":
          return "Extensão do Arquivo"   
        default:
          break;
      }
    },
    removerArquivosHandler(data){
      if(data.descricao){
        this.removerArquivoHandler(data)
      }else{
        this.removerDiretorioArquivosHandler(data)
      }
    },
    removerDiretorioArquivosHandler(diretorio) {
      this.$confirm("Deseja remover o diretório selecionado?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.removerDiretorioArquivo(diretorio);
      });
    },
    removerDiretorioArquivo(diretorio) {
      let payload = { id: diretorio.id, idCliente: this.cliente.id};

      this.showLoading();
      this.removerDiretorioArquivos(payload)
        .then(resultado => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível comunicar-se com o servidor");
        });
    },
    formatarLabelArquivo(arquivo) {
      if(arquivo.descricao != undefined){
        return "normal";
      }
      return "bold";
    },

    formatarIconeTreeArquivo(arquivo) {
      if(arquivo.descricao != undefined) {
        return 'el-icon-document'
      }
      return 'el-icon-folder-opened'
    },
    exibirDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = true;
    },
    fecharDialogCriarDiretorioArquivo() {
      this.visibilidadeCriarDiretorioDialogArquivo = false;
    },

    // VISITAS
    exibirGravarVisitaDialog() {
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = true
    },
    fecharGravarVisitaDialog() {
      this.visitaSelecionada = undefined;
      this.visibilidadeGravarVisitaDialog = false;
    },

    exibirGravarRegistroCobrancaDialog() {
      this.visibilidadeGravarRegistroCobranca = true
    },

    fecharGravarRegistroCobrancaDialog() {
      this.visibilidadeGravarRegistroCobranca = false
    },

    alterarVisita(visita, column) {
      if (column.columnKey == "acoes") { return; }

      let payload = { id: visita.id };

      this.showLoading();
      this.recuperarVisita(payload)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.visitaSelecionada = resultado.item;
              this.visibilidadeGravarVisitaDialog = true;
              break;
          }
        }).catch(() => {
          this.hideLoading();
        });
    },

    confirmarRemocaoVisita(visita) {
      this.$confirm('Deseja realmente remover esta Visita?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.removerVisitaHandler(visita);
      }).catch(() => { });

    },

    removerVisitaHandler(visita) {
      const payload = {
        id: visita.id,
        cliente: { id: this.cliente.id }
      };

      this.showLoading();
      this.removerVisita(payload)
        .then(resultado => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.visitaSelecionadaRowClick = undefined
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.$message.error('Não foi possível conectar-se com o servidor');
        }).finally(() => {
          this.hideLoading();
        });
    },

    // RECIBOS
    exibirContratosAprovadosEFinalizados() {
      this.visualizarContratosAprovados = !this.visualizarContratosAprovados
      this.idContratoSelecionado = undefined
      this.reciboSelecionado = undefined
    },
    exibirPagarReciboDialog() {
      this.visibilidadePagarReciboDialog = true
    },
    fecharPagarReciboDialog() {
      this.visibilidadePagarReciboDialog = false;
    },
    exibirPagarValorEmAbertoDialog() {
      this.visibilidadePagarValorEmAbertoDialog = true
    },
    fecharPagarValorEmAbertoDialog() {
      this.visibilidadePagarValorEmAbertoDialog = false;
    },
    exibirPagarReciboParcialmenteDialog() {
      this.visibilidadePagarReciboParcialmente = true
    },
    fecharPagarReciboParcialmenteDialog() {
      this.visibilidadePagarReciboParcialmente = false;
    },
    concluirPagamentoParcial(resultado) {
      this.recibosContratoSelecionado = resultado.lista
      this.visibilidadePagarValorEmAbertoDialog = false;
    },
    concluirPagamentoRecibo(resultado) {
      this.recibosContratoSelecionado = resultado.lista
      this.visibilidadePagarReciboDialog = false;
      this.visibilidadePagarReciboParcialmente = false;
    },
    exibirLiberarRepasseDialog() {
      this.visibilidadeLiberarRepasseDialog = true
    },
    fecharLiberarRepasseDialog() {
      this.visibilidadeLiberarRepasseDialog = false;
    },
    concluirPagamentoRepasse(resultado) {
      this.recibosContratoSelecionado = resultado.lista
      this.visibilidadeLiberarRepasseDialog = false;
    },
    exibirGerarBoletosEmAbertoDialog() {
      this.recibosDisponiveisParaGeracao = [...this.recibosContratoSelecionado];
      this.visibilidadeGerarBoletosEmAbertoDialog = true
    },
    fecharGerarBoletosEmAbertoDialog() {
      this.visibilidadeGerarBoletosEmAbertoDialog = false;
    },
    exibirGerarDemonstrativoDialog() {
      this.visibilidadeGerarDemonstrativoDialog = true
    },
    fecharGerarDemonstrativoDialog() {
      this.visibilidadeGerarDemonstrativoDialog = false;
    },
    exibirGerarBoletoDialog() {
      if(this.contratoSelecionado.contaBancariaImobiliaria.banco === 'CORA' &&
      !this.reciboSelecionado.dataRegistro) {
        this.exibirAlert('Atenção', 'Não é possível gerar este boleto sem registro.')
        return;
      }     
      this.visibilidadeGerarBoletoDialog = true
    },
    fecharGerarBoletoDialog() {
      this.visibilidadeGerarBoletoDialog = false;
    },
    exibirProrrogarBoletoDialog() {
      this.visibilidadeProrrogarBoletoDialog = true
    },
    fecharProrrogarBoletoDialog() {
      this.visibilidadeProrrogarBoletoDialog = false;
    },
    concluirProrrogacao(resultado) {
      this.recibosContratoSelecionado = resultado.lista
      this.visibilidadeProrrogarBoletoDialog = false;
    },
    exibirAlterarPeriodoDialog(){
      this.visibilidadeAlterarPeriodoRecibo = true;
    },
    fecharAlterarPeriodoDialog(){
      this.visibilidadeAlterarPeriodoRecibo = false;
    },
    concluirAlterarPeriodoRecibo(resultado) {
      this.recibosContratoSelecionado = resultado.lista
      this.visibilidadeAlterarPeriodoRecibo = false;
    },
    exibirAlterarTaxaAdmDialog() {
      this.visibilidadeAlterarTaxaAdmDialog = true
    },
    fecharAlterarTaxaAdmDialog() {
      this.visibilidadeAlterarTaxaAdmDialog = false;
    },
    exibirGravarItemReciboDialog() {
      if(this.contratoSelecionado.imovel.nome.includes('LOCATARIO') && this.contratoSelecionado.contaBancariaImobiliaria.banco === 'CORA' &&
        this.reciboSelecionado.dataRegistro) {
          this.exibirAlert('Atenção', 'O recibo que você está tentando modificar já se encontra registrado no banco. Para prosseguir com esta operação, é necessário primeiro cancelar o recibo atual em: Remessas/Títulos via API > Títulos via API > Controle de Títulos.')
          return;
        }      

      this.visibilidadeGravarItemReciboDialog = true
    },
    fecharGravarItemReciboDialog(listaRecibos) {
      if (listaRecibos) {
        this.recibosContratoSelecionado = listaRecibos

        if(this.contratoSelecionado.imovel.nome.includes('LOCATARIO') && 
        ['ASAAS'].includes(this.contratoSelecionado.contaBancariaImobiliaria.banco)
          && this.reciboSelecionado.dataRegistro) {
            this.exibirAlert('Atenção', 'A mudança de valor deste recibo na base de dados do Imob ainda não reflete o valor registrado no banco, é necessário atualizar esta diferença no Controle de títulos em: Remessas/Títulos via API > Títulos via API > Controle de Títulos.')
        }  
      }    
      this.visibilidadeGravarItemReciboDialog = false;
    },

    //OBSERVACOES
    exibirObservacao(observacaoSelecionada) {
      this.observacaoSelecionada = observacaoSelecionada
    },

    //DETALHES - Contato Adicional
    formatarTipoContatoAdicional(contato) {
      return Util.getLabel(TIPOS_CONTATOS, contato.tipo);
    },

    exibirAdicionarNovoContatoAdicional() {
      this.contatoAlternativo = {}
      this.visibilidadeAdicionarContatoAdicionalDilalog = true
    },

    exibirAdicionarContatoAdicionalDialog(contato) {
      var i;
      this.showLoading();
      for (i = 0; i < this.cliente.contatosAlternativos.length; i++) {
        if (this.cliente.contatosAlternativos[i] === contato) {
          this.indexContatoAdicional = i;
        }
      }
      this.contatoAlternativo = Object.assign({}, contato);
      this.visibilidadeAdicionarContatoAdicionalDilalog = true
      this.hideLoading();
    },
    fecharAdicionarContatoAdicionalDialog() {
      this.visibilidadeAdicionarContatoAdicionalDilalog = false;
    },
    labelMotivoBloqueio(){
      return this.reciboSelecionado.motivoBloqueio
    },
    label1viaGerada(){
      if(this.isLocatario){ return "1ª Via do Recibo Gerada"
      }else{
        return "1ª Via do Repasse Gerada"
      }
    },
    handlerGerarDemonstrativos() {
      const idsRepasses = this.recibosContratoSelecionado.filter(item => item.status === 'PAGO' )
      .map(item => item.id );

      const payload = {
        recibos: idsRepasses
      };

      this.showLoading();
      this.gerarTodosDemonstrativosRepasse(payload)
      .then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            window.open(resultado.item, "_blank");
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
        }
      })
      .catch(() => {
        this.$message.error("Não foi possivel conectar-se ao servidor");
      })
      .finally(() => {
        this.hideLoading();
      })
    },
    gerarReciboPagamentoParcial() {
      let payload = {
        pagamentoParcial: {
          id: this.pagamentoSelecionado.id,
          recibo : {
            id: this.reciboSelecionado.id
          }
        }
      };

      this.showLoading();
      this.gerarReciboPagamento(payload)
      .then(resultado => {
        this.hideLoading();
        window.open(resultado.item, "_blank");
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro.");
      });
    },
    irParaSecao(){
      location.href = '#novo'
      this.tabSelecionadaRecibos = 'itens'
      this.pagamentoSelecionado = undefined
    },
    retrairBotoes(){
      this.hoverRemover = false;
      this.hoverGravar = false;
    },
    expandGravar(){
      this.retrairBotoes();
      this.hoverGravar = !this.hoverGravar
    },
    expandRemover(){
      this.retrairBotoes();
      this.hoverRemover = !this.hoverRemover
    },
    valorSeRepasseBeneficiario(recibo) {
      let valor = recibo.valor;

      recibo.itensRecibo.forEach(item => {
        if(item.nome.includes('Repasse ao Beneficiário')) {
          valor -= item.valor;
        }
      })

      return valor;
    }
  }
}